import React, { useCallback, useEffect, useState, forwardRef, useContext, useRef } from "react";


import { Chat24Filled, Dismiss24Regular, EmojiRegular, SendFilled, AttachRegular  } from "@fluentui/react-icons";
import FluentChatOverlay from "./FluentChatOverlay";
import { useIntl } from "react-intl";
import { ChatContext, useChat } from "../hooks/useChat";
import { MAX_MESSAGE_LENGTH } from "../../utils/chat-message";
import { PrivateChatContext } from "../chat/PrivateChatContext";


export default function FluentChatPrivate ({scene, 
    hubChannel, 
    presences, 
    mySessionId, 
    canTextChat,
    selectedUser,
    ...rest
  }) {
  const [message, setMessage] = useState("");
  const inputRef = useRef();
  const intl = useIntl();
  const [isCommand, setIsCommand] = useState(false);

    const {
        privateMessageGroups, 
        sendPrivateMessage, 
        receiver, 
        setReceiver, 
        tabs, 
        sendMessageSpawn,
        readAllMesages,
        setPrivateUnreadMessages,
    } = useContext(PrivateChatContext)
  const typingTimeoutRef = useRef();

  const isOverMaxLength = message.length > MAX_MESSAGE_LENGTH;
  const isDisabled = message.length === 0 || isOverMaxLength || !canTextChat;

  useEffect(() => {
    setReceiver(selectedUser?.id);
  }, [selectedUser])


    const onSendMessage = useCallback(() => {
        sendPrivateMessage(message, receiver, mySessionId)
        setMessage("");
    }, [message, setMessage, receiver, sendPrivateMessage]);

    const onSpawnMessage = () => {
      spawnChatMessage(message);
      setMessage("");
    };

    const onSpawn = (src) => {
        window.APP.scene.emit("add_media", { src });
    };

    const onUploadAttachments = useCallback(
      e => {
        // TODO: Right now there's no way to upload files to the chat only.
        // When we add the place menu whcih will have an explicit button for uploading files,
        // should we make this attach button only upload to chat?
        for (const file of e.target.files) {
          sendMessageSpawn(file, receiver, mySessionId);
        }
      },
      [receiver, sendMessageSpawn]
    );

    useEffect(() => {
        setPrivateUnreadMessages(false);
    }, [receiver])

  const onKeyDown = useCallback(
    e => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        if (e.target.value.length <= MAX_MESSAGE_LENGTH) {
          sendPrivateMessage(e.target.value, receiver, mySessionId)
          setMessage("");
        }
      } else if (e.key === "Escape") {
        // closeAIChat();
      }
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = setTimeout(() => window.APP.hubChannel.endTyping(), 500);
      window.APP.hubChannel.beginTyping();
    },
    [sendPrivateMessage, setMessage, canTextChat, receiver]
  );

  const onSelectEmoji = useCallback(
    ({ emoji, pickerRemainedOpen }) => {
      setMessage(message => message + emoji.native);
      // If the picker remained open, avoid selecting the input so that the
      // user can keep picking emojis.
      if (!pickerRemainedOpen) inputRef.current.select();
    },
    [setMessage, inputRef]
  );

    const myPrivateMessageGroups = privateMessageGroups.filter(group => {
        if(group.receiver === receiver && group.senderSessionId === mySessionId) {
            return group;
        }

        if(group.senderSessionId === receiver && group.receiver === mySessionId) {
            return group;
        }
    });

    // useEffect(() => {
    //   readAllMesages(selectedUser?.id);
    // }, [privateMessageGroups])

  return (
    <>
      <FluentChatOverlay
        hubChannel={hubChannel}
        scene={scene}
        messageGroups={myPrivateMessageGroups}
        onSendMessage={onSendMessage}
        onUploadAttachments={onUploadAttachments}
        onKeyDown={onKeyDown}
        message={message}
        setMessage={setMessage}
        isDisabled={isDisabled}
        isCommand={isCommand}
        onSpawn={onSpawn}
        onSelectEmoji={onSelectEmoji}
        selectedUser={selectedUser}
        canTextChat={canTextChat}
        {...rest}
     />
    </>
  );
}

export const ChatMessageList = forwardRef(({ children, ...rest }, ref) => (
  <ul {...rest} ref={ref}>
    {children}
  </ul>
));


ChatMessageList.displayName = "ChatMessageList";
